import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const PrivacyRights = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-16 px-4 mt-10">
        <div className="max-w-4xl mx-auto">
          <motion.h1
            className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-400 mb-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Your Privacy Rights
          </motion.h1>

          <p className="text-sm text-gray-500 text-center mb-8">Understand and exercise your rights over your personal data</p>

          <div className="bg-white rounded-2xl shadow-md p-6 space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Access</h2>
              <p className="text-gray-600 leading-relaxed">
                You can request access to the personal data we hold about you and obtain a copy of that data.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Correction</h3>
              <p className="text-gray-600 leading-relaxed">
                If your personal data is inaccurate or incomplete, you may request that we correct it.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Deletion / Right to be Forgotten</h3>
              <p className="text-gray-600 leading-relaxed">
                In certain circumstances, you may request deletion of your personal data. We may retain some information as required by law or to complete transactions.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Objection & Restriction</h3>
              <p className="text-gray-600 leading-relaxed">
                You can object to or request restriction of certain processing operations (e.g., direct marketing).
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">How to Exercise Your Rights</h3>
              <p className="text-gray-600 leading-relaxed">
                To exercise any of these rights, contact us at <strong>privacy@hlc.com</strong> with details of your request. We aim to respond within a reasonable timeframe and in accordance with applicable law.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyRights;
